import axios from "axios";

const fetchDate = () => axios.get(`/api/v1/npi_updated_date`);

const npiUpdatedDateApi = {
  fetchDate,
};

export default npiUpdatedDateApi;
